// API 문서 상단 설명(목록형)을 렌더하는 컴포넌트
import classes from './DocDesc.module.css';

/**
 * 목록 항목을 { text, sub, node } 형태로 정규화한다.
 * 세 형태를 받는다.
 *   - 문자열: HTML 로 렌더한다
 *   - { text, sub }: 항목 텍스트와 부가설명
 *   - React 노드: 그대로 렌더한다. 목록 안에 apiActionTable 같은 헬퍼 결과가 들어가는 경우다
 */
function normalizeItem(item) {
  if (typeof item === 'string') return { text: item };
  // React 엘리먼트는 $$typeof 를 가진다. { text, sub } 객체와 구분하는 기준이다
  if (item && item.$$typeof) return { node: item };
  return item;
}

/**
 * 문서 설명.
 * 목록 앞 텍스트(intro), 목록 항목(items), 하단 강조 박스(notes)를 렌더한다.
 * intro·각 항목·notes 는 문서 데이터가 HTML 문자열을 담고 있어 dangerouslySetInnerHTML 로 렌더한다.
 */
const DocDesc = ({ intro, items, notes }) => {
  const listItems = items || [];
  const noteItems = notes || [];

  return (
    <div className={classes.container}>
      {intro && (
        <div className={classes.intro} dangerouslySetInnerHTML={{ __html: intro }} />
      )}

      {listItems.length > 0 && (
        <ul className={classes.list}>
          {listItems.map((raw, i) => {
            const { text, sub, node } = normalizeItem(raw);
            return (
              <li className={classes.item} key={i}>
                {node || <span dangerouslySetInnerHTML={{ __html: text }} />}
                {sub && (
                  <div
                    className={classes.sub}
                    dangerouslySetInnerHTML={{ __html: sub }}
                  />
                )}
              </li>
            );
          })}
        </ul>
      )}

      {/* ParamDesc 의 notes 와 같은 모양으로 둔다. 두 컴포넌트에서 같은 이름의 슬롯이
          다르게 보이면 문서 작성자가 어느 쪽 표현을 기대할지 알 수 없다 */}
      {noteItems.length > 0 && (
        <ul className={classes.notes}>
          {noteItems.map((note, i) => (
            <li
              className={classes.noteItem}
              key={i}
              dangerouslySetInnerHTML={{ __html: note }}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default DocDesc;
